import RouteItem from ".";
import Academic from "../pages/faculty/Academic";
import Administrative from "../pages/faculty/Administrative";
import FacultyAchievement from "../pages/faculty/FacultyAchievement";

// Faculty SubMenu Pages
export const facultyRoutes: RouteItem = {
  key: "router-faculty",
  title: "Faculty",
  tooltip: "Faculty",
  path: "/faculty",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-faculty-academic",
      title: "Academic",
      tooltip: "Academic",
      path: "academic",
      enabled: true,
      component: Academic,
      appendDivider: true,
    },
    {
      key: "router-faculty-administrative",
      title: "Administrative",
      tooltip: "Administrative",
      path: "administrative",
      enabled: true,
      component: Administrative,
      appendDivider: true,
    },
    {
      key: "router-faculty-achievements",
      title: "Faculty Achievements",
      tooltip: "Faculty Achievements",
      path: "faculty-achievements",
      enabled: true,
      component: FacultyAchievement,
      appendDivider: true,
    },
  ],
};
